// extracted by mini-css-extract-plugin
export var button = "_ax-4";
export var hasDarkBackground = "_ax-7";
export var hasLightBackground = "_ax-6";
export var iconWrapper = "_ax-0";
export var large = "_ax-2";
export var medium = "_ax-1";
export var small = "_ax-5";
export var xsmall = "_ax-3";